module.exports = __webpack_public_path__ + "img/approve.a2fe4418.svg";